import * as React from 'react';
import BlogMeta from '../BlogMeta/BlogMeta.js';

const BlogIntro = ({ summary , publishDate , readingTime , minutesLabel , locale  })=>/*#__PURE__*/ React.createElement("div", {
        className: "blog-intro"
    }, summary && /*#__PURE__*/ React.createElement("p", {
        className: "blog-intro__summary"
    }, summary), /*#__PURE__*/ React.createElement(BlogMeta, {
        publishDate: publishDate,
        readingTime: readingTime,
        minutesLabel: minutesLabel,
        locale: locale
    }))
;

export { BlogIntro as default };
//# sourceMappingURL=BlogIntro.js.map
